import { Image, Descriptions, Button, Row, Col, Tag } from 'antd';
import { ArrowLeftOutlined, ShoppingOutlined } from "@ant-design/icons"
import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom"
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { UserContext } from "../Context/UserContext";

const DetailProduct = () => {
    let {id} = useParams()
    const [ products, setProducts ] = useState({}) 
    const [,,, setDashboard] = useContext(UserContext)
    let history = useHistory()
 
    setDashboard(false)

    useEffect(()=>{
        const fetchData = async ()=>{
            let result = await axios.get(`https://backend-sportyan.vercel.app/api/products/${id}`)
            let dataProducts = result.data
            setProducts(dataProducts) 
        }
        fetchData()
    },[id])

    const HandleBuy = ()=>{
        history.push(`/create-order/${id}`)
    }

    const HandleBack = ()=>{
        history.goBack()
    }

    let categories = products.category?.map(function(item){
        return (<Tag color='#f50'> {item.category.name}</Tag>)
    })

    return(
        <>
        <Button type="danger" icon={<ArrowLeftOutlined />} size="large" style={{marginBottom: "20px"}} onClick={HandleBack}>
            Kembali
        </Button>
            <Row>
                <Col span={8}>
                    <Image src={products.image} style={{maxWidth: '350px'}}></Image>
                </Col>
                <Col span={16}>
                <Descriptions title="Product Info" bordered>    
                    <Descriptions.Item label="Title" span={3}>{products.name}</Descriptions.Item> 
                    <Descriptions.Item label="Price"span={3}>{products.price}</Descriptions.Item>
                    <Descriptions.Item label="Stock"span={3}>{products.stock}</Descriptions.Item>
                    <Descriptions.Item label="Categories"span={3}>{categories}</Descriptions.Item>
                    <Descriptions.Item label="Description" span={3}>{products.description}</Descriptions.Item>
                </Descriptions>

                <Button onClick={HandleBuy} type="default" icon={<ShoppingOutlined />} size="large" style={{margin: "40px 0 0 80px", background: "#03AC0E", color: "white"}}>
                    Buy
                </Button>
                </Col>
            </Row>
        </>
    )
}

export default DetailProduct